import { render, staticRenderFns } from "./client-publish-widget.vue?vue&type=template&id=345ddf56&scoped=true&"
import script from "./client-publish-widget.vue?vue&type=script&lang=js&"
export * from "./client-publish-widget.vue?vue&type=script&lang=js&"
import style0 from "./client-publish-widget.vue?vue&type=style&index=0&id=345ddf56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345ddf56",
  null
  
)

export default component.exports